import { useContext } from "react";
import { toast } from "react-toastify";
import { Store } from "../Store";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function CartScreenTouchItemRelative(props) {
  const {
    ozetle,
    item,
    cart,
    setShowChangePrice,
    setSelectedProduct,
    setSelectedProductPrice,
    setSelectedIndex,
    setShowAddCard,
    index,
  } = props;

  const { dispatch: ctxDispatch } = useContext(Store);

  return (
    <div
      className="btn-group"
      style={{
        marginBottom: "0.3rem",
        marginLeft: "0.3rem",
        marginRight: "0.3rem",
      }}
    >
      {!ozetle && (item.customerName || cart.description) && (
        <div
          style={{
            height: "40px",
            width: "30px",
            overflow: "hidden",
          }}
        ></div>
      )}
      <div
        className="pe-2"
        style={{
          height: "40px",
          aspectRatio: "1/1",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          fontSize: "12px",
        }}
      >
        <i className="text-warning fas fa-star" />
      </div>
      <div
        onClick={() => {
          if (ozetle) {
            toast.info("Bu işlemi yapmak için özet modundan çıkmalısınız");
            return;
          }
          if (!item.isPartialPaid) {
            setSelectedIndex(index);
            setShowAddCard(true);
          } else {
            toast.error("Ödendi, değişiklik yapılmaz!");
          }
        }}
        className="btn btn-outline-danger text-dark rounded"
        style={{
          height: "40px",
          aspectRatio: "7/1",
          textAlign: "start",
          overflow: "hidden",
          borderTop: "0px solid #ddd",
          borderLeft: "0px solid #ddd",
          borderRight: "0px solid #ddd",
          borderBottom: "1px solid #ddd",
          borderRadius: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "baseline",
          }}
        >
          <div>
            <span className="text-bold">{item.quantity}</span>
            &nbsp;
            <span
              className={
                item.isPartialPaid ? "textDecorationLine text-secondary" : ""
              }
            >
              {item.menuName}
            </span>
            {item.answers?.length === 1 && (
              <div
                className={
                  item.isPartialPaid
                    ? "small-font text-secondary text-bold"
                    : "small-font text-danger text-bold"
                }
              >
                {item.answers[0].answers[0].answer}
              </div>
            )}
          </div>
          <div>
            {!item.feature &&
              !!item.mainPrice &&
              item.mainPrice > item.price && (
                <>
                  <span className="text-muted textDecorationLine">
                    {turkishCurrencyFormatterNoPrecision(item.mainPrice)}
                  </span>
                  &nbsp;
                </>
              )}
            {!!item.feature && item.feature.mainPrice > item.feature.price && (
              <>
                <span
                  className="text-muted textDecorationLine"
                  style={{ fontSize: "12px" }}
                >
                  {turkishCurrencyFormatterNoPrecision(
                    (item.mainPrice || item.price) +
                      (item.feature
                        ? item.feature.mainPrice || item.feature.price
                        : 0)
                  )}
                </span>
                &nbsp;&nbsp;
              </>
            )}
            <span
              className={
                item.isPartialPaid
                  ? "textDecorationLine text-bold text-secondary"
                  : item.isGift || cart.isStaffMeal
                  ? "isGift text-bold text-warning"
                  : "text-bold text-warning"
              }
            >
              {turkishCurrencyFormatterNoPrecision(
                ((item.feature ? item.feature.price : 0) + item.price) *
                  item.quantity
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
